// extracted by mini-css-extract-plugin
export default {"label":"Search_label__QS0JO","input":"Search_input__BuEAl"};